import { ethers } from 'ethers';
import EquivalentsNFTAbi from '../abi/EquivalentsNFT.json';

const CONTRACT_ADDRESS = process.env.REACT_APP_CONTRACT_ADDRESS;

export async function connectWallet() {
  if (!window.ethereum) {
    throw new Error("MetaMask is not installed. Please install MetaMask to mint.");
  }
  await window.ethereum.request({ method: 'eth_requestAccounts' });
  const provider = new ethers.BrowserProvider(window.ethereum);
  const signer = await provider.getSigner();
  return signer;
}

export async function mintNFT(tokenId, metadataUrl, priceEth) {
  const signer = await connectWallet();
  const contract = new ethers.Contract(CONTRACT_ADDRESS, EquivalentsNFTAbi, signer);
  const tx = await contract.mint(tokenId, metadataUrl, {
    value: ethers.parseEther(String(priceEth)),
  });
  await tx.wait();
  return tx.hash;
}
